import { SVGProps, memo } from 'react';

function _Discord(props: SVGProps<SVGSVGElement>) {
  const { ...rest } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="1.67 3.33 16.67 13.33" {...rest}>
      <path d="m15.8 4.46-.02-.02a13.27 13.27 0 0 0-3.43-1.1 10.29 10.29 0 0 0-.45.93 12.1 12.1 0 0 0-3.8 0 9.41 9.41 0 0 0-.46-.93h-.03A13.24 13.24 0 0 0 4.2 4.45a15.33 15.33 0 0 0-2.44 10 13.59 13.59 0 0 0 4.2 2.2l.02-.02a10.47 10.47 0 0 0 .85-1.5l-.01-.01-.02-.02a8.92 8.92 0 0 1-1.33-.7v-.02l.02-.02a7.39 7.39 0 0 0 .29-.22h.03a9.44 9.44 0 0 0 8.4 0h.03a6.83 6.83 0 0 0 .28.27l-.01.02-.02.02a8.36 8.36 0 0 1-1.33.68.06.06 0 0 0 0 .05 11.76 11.76 0 0 0 .88 1.47h.03a13.54 13.54 0 0 0 4.2-2.24c.34-3.78-.59-7.05-2.47-9.96Zm-8.56 7.97c-.83 0-1.5-.8-1.5-1.77S6.4 8.9 7.24 8.9s1.5.8 1.5 1.76c0 .98-.67 1.77-1.5 1.77Zm5.53 0c-.82 0-1.5-.8-1.5-1.77s.67-1.76 1.5-1.76c.85 0 1.52.8 1.5 1.76 0 .98-.65 1.77-1.5 1.77Z" />
    </svg>
  );
}

export const Discord = memo(_Discord);
